<template lang="pug">
.ExcelLayer
  .CommonTabs
    router-link.CommonTabs-item(
      v-if='$store.getters.permissions.canEditAggregateInfoLayer',
      tag='div',
      :to='{ name: "excel-layer-settings", params: { layerId: routeLayerId } }',
      :class='{ "CommonTabs-item--active": $route.name === "excel-layer-settings" }'
    ) Настройки
    router-link.CommonTabs-item(
      tag='div',
      :to='{ name: "excel-object-list", params: { layerId: routeLayerId } }',
      :class='{ "CommonTabs-item--active": $route.name === "excel-object-list" }'
    ) Все записи
    router-link.CommonTabs-item(
      tag='div',
      :to='{ name: "excel-layer-history", params: { layerId: routeLayerId } }',
      :class='{ "CommonTabs-item--active": $route.name === "excel-layer-history" }'
    ) История изменений
    router-link.CommonTabs-item(
      v-if='$store.getters.permissions.canCreateAggregateInfoLayer && log',
      tag='div',
      :to='{ name: "excel-layer-create-log", params: { layerId: routeLayerId } }',
      :class='{ "CommonTabs-item--active": $route.name === "excel-layer-create-log" }'
    ) Журнал создания слоя
  router-view(v-if='layerSettings || routeLayerId === "new"')
</template>

<script>
export default {
  name: 'excel-layer',

  computed: {
    routeLayerId() {
      return this.$route.params.layerId
    },
    layerSettings() {
      return this.$store.getters.excelLayerSettings
    },
    log() {
      if (!this.layerSettings || !this.layerSettings.log) {
        return null
      }

      //Для созданных ранее слоев в логе один пробел
      if (!this.layerSettings.log.trim()) {
        return null
      }

      return this.layerSettings.log.trim().replace('Слой загружен успешно', '')
    }
  },

  beforeDestroy() {
    this.$store.commit('setExcelLayersKeyValue', {
      key: 'excelLayerSettings',
      value: null
    })
  },

  mounted() {
    this.getLayer()
  },

  methods: {
    getLayer() {
      if (this.routeLayerId === 'new') {
        return
      }
      this.$store.dispatch('getExcelLayerSettings', {
        id: this.routeLayerId
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/excel-layers/ExcelLayer.vue